import { mapActions, mapState } from "pinia";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  data() {
    return {
      selectedProposalForCounter: null,
    };
  },
  computed: {
    ...mapState(useCollaboratorStore, [
      "isCounterOfferModalVisible",
      "isInvitationReviewModalVisible",
      "isProposalReviewModalVisible",
      "selectedInvitationReview",
      "selectedProposalReview",
    ]),
  },
  methods: {
    ...mapActions(useCollaboratorStore, [
      "acceptInvitation",
      "denyInvitation",
      "closeCounterOfferModal",
      "openCounterOfferModal",
      "openInvitationReviewModal",
      "closeInvitationReviewModal",
      "openProposalReviewModal",
      "closeProposalReviewModal",
      "createCounterOffer",
    ]),
    onAcceptInvitation() {
      const invitation =
        this.selectedInvitationReview || this.selectedProposalReview;

      if (!invitation) {
        return;
      }

      return this.acceptInvitation(
        invitation.publicationId,
        invitation.orgId,
        invitation.contract.contract_id,
        true,
      );
    },
    onDeclineInvitation() {
      const invitation =
        this.selectedInvitationReview || this.selectedProposalReview;

      if (!invitation) {
        return;
      }

      return this.denyInvitation(
        invitation.publicationId,
        invitation.orgId,
        true,
      );
    },
    onCounterInvitation(proposal) {
      this.selectedProposalForCounter = proposal || this.selectedProposalReview;

      if (this.isInvitationReviewModalVisible) {
        this.closeInvitationReviewModal();
      } else if (this.isProposalReviewModalVisible) {
        this.closeProposalReviewModal();
      }

      this.openCounterOfferModal();
    },
    onSubmitCounterOffer(formData) {
      this.createCounterOffer(this.selectedProposalForCounter, formData, true);
      this.selectedProposalForCounter = null;
    },
    onCancelCounterOffer() {
      this.closeCounterOfferModal();
      this.openProposalReviewModal(this.selectedProposalForCounter);
    },
  },
};
